import QRCode from 'react-qr-code';

import { useCustomerLoyalty } from '@/context/LoyaltyContext';
import { useLoyaltyProgramContext } from '@/context/LoyaltyProgramContext';
import { formatText } from '@/helpers/functions/text';
import type { T_ScanQRProps } from '@/types/ScanQR';

export const ScanQR = ({ selectedPassApplication }: T_ScanQRProps) => {
  const { qrCodeUrl } = useLoyaltyProgramContext();
  const { customerLoyalty } = useCustomerLoyalty();

  const formattedPassApplicationName =
    selectedPassApplication && formatText(selectedPassApplication);

  const codeToScan = qrCodeUrl ?? customerLoyalty?.basicInfo?.passLink;

  return codeToScan ? (
    <>
      <h3 className='mb-2'>
        {selectedPassApplication
          ? `Your ${formattedPassApplicationName} loyalty card is ready`
          : 'Your current loyalty card is ready'}
      </h3>
      <h6>Scan the QR code using your phone to get your card</h6>

      <div className='mt-3 flex w-full justify-center'>
        <QRCode
          size={150}
          style={{ height: 'auto', maxWidth: '100%' }}
          value={codeToScan}
          viewBox='0 0 256 256'
        />
      </div>
    </>
  ) : (
    <h4 className='mb-2'>No QR available for {formattedPassApplicationName ?? 'your card'}</h4>
  );
};
